import SharedComponents from '@webcarelbj/shared-components'

export default defineNuxtPlugin({
  name: 'shared-components',
  setup(nuxtApp) {
    if (!nuxtApp.vueApp.config.globalProperties.$sharedComponentsInitialized) {
      nuxtApp.vueApp.use(SharedComponents)
    }
  },
})
